import Badge from "../components/Badge";
import BaseAlert from "../components/BaseAlert";
import BaseButton from "../components/BaseButton";
import BaseCheckbox from "../components/BaseCheckbox";
import BaseInput from "../components/BaseInput";
import BaseDropdown from "../components/BaseDropdown";
import BaseNav from "../components/BaseNav";
import BaseSpinner from "../components/BaseSpinner";
import BaseAvatar from "../components/BaseAvatar";
import BasePagination from "../components/BasePagination";
import BaseProgress from "../components/BaseProgress";
import BaseRadio from "../components/BaseRadio";
import BaseSlider from "../components/BaseSlider";
import BaseSwitch from "../components/BaseSwitch";
import BaseTable from "../components/BaseTable";
import BaseHeader from "../components/BaseHeader";
import Card from "../components/Card";
import StatsCard from "../components/StatsCard";
import Modal from "../components/Modal";
import TabPane from "../components/Tabs/TabPane";
import Tabs from "../components/Tabs/Tabs";
import ModalTopbar from "../components/ModalTopbar";
import RightNav from "../components/RightNav";
import LeftNav from "../components/LeftNav";
import TopNav from "../components/TopNav";
import { VueMasonryPlugin } from "vue-masonry";

import BTooltipDirective from "bootstrap-vue/es/directives/tooltip";
// import BToggleDirective from "bootstrap-vue/es/directives/toggle";
import BTCollapse from "bootstrap-vue/es/components/collapse";


export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(BaseTable.name, BaseTable);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseSpinner.name, BaseSpinner);
    Vue.component(BaseAvatar.name, BaseAvatar);
    Vue.component(Card.name, Card);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(Modal.name, Modal);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Tabs.name, Tabs);
    Vue.component(RightNav.name, RightNav);
    Vue.component(TopNav.name, TopNav);
    Vue.component(LeftNav.name, LeftNav);
    Vue.component(ModalTopbar.name, ModalTopbar);
    Vue.use(VueMasonryPlugin);
    Vue.use(BTooltipDirective);
    // Vue.use(BToggleDirective);
    Vue.use(BTCollapse);
  }
};
